/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */


/* Получение facets для фильтров (multiselect & inputSearch) */

export const mapTableFilterSuggestResponse = (response: { suggestEntities?: Array<{ text: string; }> }) =>
    response?.suggestEntities?.map(r => r.text) ?? [];
